import { useId, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";

/** Why an import can't start yet: shown beside its button, never hidden (F16). */
export type ImportBlocker = "chooseFiles" | "enterRemote" | "nameCorpus" | "workflowsLoading" | "workflowsFailed" | "noContentYet" | "noImportWorkflow" | "connectRepository" | "installApp" | "consentPrivate";

/** The form's button, with the reason it is greyed out beside it, and what resolves it where the form can. */
export default function ImportSubmit({ label, blocker, submitting, resolve }: { label: string; blocker: ImportBlocker | null; submitting: boolean; resolve?: ReactNode }) {
  const { t } = useTranslation();
  const reasonId = useId();
  return (
    <div className="flex flex-wrap items-center gap-3">
      <AppButton type="submit" variant="primary" disabled={submitting || blocker !== null} aria-describedby={blocker === null ? undefined : reasonId}>
        {label}
      </AppButton>
      {blocker === null || submitting ? null : <p id={reasonId} className="app-help-text text-sm">{t(`sources.import.blockers.${blocker}`)}</p>}
      {blocker === null || submitting ? null : resolve}
    </div>
  );
}
